var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _path8, _path9, _rect5, _rect6, _rect7, _rect8, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 474,
    height: 404,
    viewBox: "0 0 474 404",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.365 2.50371C257.033 0.963402 260.32 0.963396 262.988 2.5037L415.507 90.5608C418.175 92.1011 419.819 94.9477 419.819 98.0284V274.143C419.819 277.223 418.175 280.07 415.507 281.61L262.988 369.667C260.32 371.208 257.033 371.208 254.365 369.667L101.846 281.61C99.1777 280.07 97.5342 277.223 97.5342 274.143V98.0284C97.5342 94.9477 99.1777 92.1011 101.846 90.5608L254.365 2.50371Z",
    fill: "url(#paint0_linear_910_18001)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.368 30.2147C257.036 28.6743 260.323 28.6743 262.99 30.2147L392.038 104.72C394.706 106.261 396.349 109.107 396.349 112.188V261.199C396.349 264.28 394.706 267.126 392.038 268.667L262.99 343.172C260.323 344.713 257.036 344.713 254.368 343.172L125.32 268.667C122.652 267.126 121.009 264.28 121.009 261.199V112.188C121.009 109.107 122.652 106.261 125.32 104.72L254.368 30.2147Z",
    fill: "url(#paint1_linear_910_18001)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.691406 356.185V332.167L185.603 329.938V354.081C185.603 362.376 171.773 370.547 164.176 372.033H23.2325C7.77576 370.052 1.76479 360.642 0.691406 356.185Z",
    fill: "#303442"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104.014 302.205C126.2 295.272 140.165 306.415 144.375 312.853C152.464 310.707 175.019 306.932 183.126 319.538C189.612 329.621 183.539 336.772 175.886 341.608C170.175 345.217 163.326 346.281 156.569 346.281H21.3813C19.6813 346.281 17.9638 346.11 16.3191 345.68C-16.3068 337.146 9.17613 312.853 29.2344 312.853C25.7678 282.149 88.4141 282.644 104.014 302.205Z",
    fill: "#414659"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3548 313.472L74.5457 318.919V329.072C73.9679 330.887 78.3096 335.51 94.3548 339.471C110.4 335.51 114.742 330.887 114.164 329.072V318.919L94.3548 313.472Z",
    fill: "#4A5066"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3548 310.377L74.5457 315.824V325.976C73.9679 327.792 78.3096 332.414 94.3548 336.376C110.4 332.414 114.742 327.792 114.164 325.976V315.824L94.3548 310.377Z",
    fill: "#5D6480"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.021 372.157L102.65 351.605L86.1836 368.071L90.1454 372.157H116.021Z",
    fill: "#252833"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 84.9453,
    y: 350.985,
    width: 18.571,
    height: 17.7044,
    rx: 1.98091,
    fill: "#4A5066"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 88.5352,
    y: 354.576,
    width: 2.84756,
    height: 7.67603,
    fill: "#232735"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 97.3242,
    y: 354.576,
    width: 2.84756,
    height: 7.67603,
    fill: "#232735"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 92.9297,
    y: 363.119,
    width: 2.84756,
    height: 2.47614,
    fill: "#232735"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M220.445 401.273V375.768C220.445 374.674 221.332 373.787 222.426 373.787H273.064C273.467 373.787 273.86 373.91 274.191 374.139L287.685 383.476C288.22 383.846 288.539 384.454 288.539 385.105V401.273C288.539 402.367 287.652 403.254 286.558 403.254H222.426C221.332 403.254 220.445 402.367 220.445 401.273Z",
    fill: "#303442"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M220.445 394.339V366.359C220.445 365.265 221.332 364.378 222.426 364.378H270.933C271.274 364.378 271.61 364.466 271.907 364.635L287.533 373.466C288.155 373.818 288.539 374.477 288.539 375.191V394.339C288.539 395.433 287.652 396.32 286.558 396.32H222.426C221.332 396.32 220.445 395.433 220.445 394.339Z",
    fill: "#414659"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 230.598,
    y: 373.787,
    width: 23.8947,
    height: 2.72375,
    fill: "#5D6480"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230.598,
    y: 378.492,
    width: 47.7895,
    height: 2.72375,
    fill: "#5D6480"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 230.598,
    y: 383.197,
    width: 47.7895,
    height: 2.72375,
    fill: "#5D6480"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 230.598,
    y: 387.902,
    width: 47.7895,
    height: 2.72375,
    fill: "#5D6480"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.085 245.953C369.28 245.794 368.499 246.318 368.34 247.123C368.181 247.928 368.705 248.709 369.511 248.868C379.451 250.826 401.609 267.038 403.97 317.802L403.972 317.836L403.975 317.87C404.837 327.144 412.254 333.96 420.61 338.663C429.031 343.403 438.83 346.246 445.302 347.422L445.352 347.432L445.403 347.437C449.076 347.845 453.33 348.496 457.307 349.379C461.309 350.269 464.928 351.373 467.391 352.652C468.629 353.296 469.458 353.925 469.916 354.494C470.336 355.017 470.385 355.397 470.29 355.752C470.168 356.207 469.721 356.928 468.482 357.87C467.266 358.794 465.43 359.822 462.813 360.936C457.675 363.125 449.693 364.711 440.005 365.801C430.353 366.886 419.139 367.467 407.615 367.701C384.568 368.171 360.37 367.256 345.132 366.268C345.131 366.268 345.13 366.268 345.129 366.268L345.429 363.09C345.477 362.584 345.134 362.124 344.636 362.025L331.086 359.334C330.511 359.22 329.963 359.628 329.907 360.212L329.705 362.355L324 361.817L323.837 363.542L329.542 364.08L329.132 368.435L323.28 367.883L323.117 369.609L328.969 370.161L328.785 372.113C328.731 372.685 329.173 373.183 329.748 373.197L343.521 373.518C344.041 373.53 344.481 373.138 344.53 372.621L344.85 369.225C344.88 369.228 344.91 369.231 344.94 369.233C360.241 370.226 384.526 371.144 407.676 370.672C419.25 370.436 430.562 369.853 440.337 368.753C450.075 367.658 458.419 366.037 463.978 363.67C466.71 362.506 468.793 361.366 470.28 360.235C471.746 359.121 472.79 357.898 473.16 356.523C473.556 355.048 473.099 353.711 472.231 352.632C471.401 351.6 470.159 350.742 468.761 350.015C465.949 348.555 462.028 347.385 457.952 346.479C453.869 345.572 449.527 344.907 445.783 344.49C439.544 343.35 430.107 340.599 422.067 336.074C413.952 331.506 407.673 325.374 406.936 317.628C404.535 266.204 381.932 248.286 370.085 245.953Z",
    fill: "#414659"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.367 59.6201C257.035 58.0797 260.322 58.0797 262.99 59.6201L368.387 120.471C371.055 122.011 372.698 124.858 372.698 127.939V249.641C372.698 252.721 371.055 255.568 368.387 257.108L262.99 317.959C260.322 319.5 257.035 319.5 254.367 317.959L148.97 257.108C146.302 255.568 144.658 252.721 144.658 249.641V127.939C144.658 124.858 146.302 122.011 148.97 120.471L254.367 59.6201Z",
    fill: "#303442"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M337.537 159.662L336.543 196.223H327.211L326.192 159.662H337.537ZM331.877 212.54C330.194 212.54 328.75 211.945 327.543 210.755C326.336 209.548 325.741 208.104 325.758 206.421C325.741 204.755 326.336 203.328 327.543 202.138C328.75 200.948 330.194 200.353 331.877 200.353C333.492 200.353 334.911 200.948 336.135 202.138C337.359 203.328 337.979 204.755 337.996 206.421C337.979 207.543 337.682 208.571 337.104 209.506C336.543 210.424 335.803 211.163 334.886 211.724C333.968 212.268 332.965 212.54 331.877 212.54Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M275.008 202.699V194.005L296.806 159.662H304.302V171.696H299.866L286.124 193.444V193.852H317.101V202.699H275.008ZM300.07 211.877V200.047L300.274 196.197V159.662H310.625V211.877H300.07Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M246.843 213.024C242.458 213.007 238.684 211.928 235.523 209.786C232.378 207.645 229.956 204.543 228.257 200.481C226.574 196.418 225.741 191.532 225.758 185.821C225.758 180.127 226.599 175.274 228.282 171.263C229.982 167.252 232.404 164.201 235.548 162.11C238.71 160.002 242.475 158.949 246.843 158.949C251.211 158.949 254.967 160.002 258.112 162.11C261.273 164.218 263.704 167.277 265.403 171.288C267.103 175.283 267.945 180.127 267.928 185.821C267.928 191.549 267.078 196.444 265.378 200.506C263.695 204.568 261.282 207.67 258.137 209.812C254.993 211.954 251.228 213.024 246.843 213.024ZM246.843 203.871C249.834 203.871 252.222 202.367 254.007 199.359C255.792 196.35 256.676 191.838 256.659 185.821C256.659 181.86 256.251 178.563 255.435 175.928C254.636 173.294 253.497 171.314 252.018 169.988C250.557 168.662 248.831 167.999 246.843 167.999C243.868 167.999 241.489 169.487 239.704 172.461C237.919 175.436 237.019 179.889 237.002 185.821C237.002 189.832 237.401 193.18 238.2 195.866C239.016 198.534 240.163 200.54 241.642 201.883C243.12 203.209 244.854 203.871 246.843 203.871Z",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M176.922 202.699V194.005L198.72 159.662H206.216V171.696H201.78L188.038 193.444V193.852H219.015V202.699H176.922ZM201.984 211.877V200.047L202.188 196.197V159.662H212.539V211.877H201.984Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_910_18001",
    x1: 258.676,
    y1: -93.1101,
    x2: 258.676,
    y2: 328.824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4353",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A95B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_910_18001",
    x1: 258.679,
    y1: -18.8088,
    x2: 258.679,
    y2: 345.662,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E4353",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762727,
    stopColor: "#8A95B9",
    stopOpacity: 0.04
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.4bb371ac940ab62c970328127186a25c.svg";
export { ForwardRef as ReactComponent };